import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  constructor(private http: HttpClient) { }

  // =========================
  // Delivery Stars
  // =========================
  getAllDeliveryStars(
    warehouseId: any,
    withPagination: boolean,
    page?: any
  ): Observable<any> {
    return this.http.get(`${environment.Server_URL}/sub-diliveries`, {
      params: {
        warehouse_id: warehouseId.toString(),
        with_pagination: withPagination ? '1' : '0',
        page: page ? page.toString() : '1'
      }
    });
  }

  createDeliveryStar(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/sub-diliveries`, data);
  }

  getDeliveryStarById(id: string): Observable<any> {
    return this.http.get(`${environment.Server_URL}/sub-diliveries/${id}`);
  }

  updateDeliveryStar(id: string, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/sub-diliveries/${id}`, data);
  }

  deleteDeliveryStar(id: string): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/sub-diliveries/${id}`);
  }

  // =========================
  // Delivery Collections
  // =========================
  getAllDeliveryCollections(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<any> {
    return this.http.get(`${environment.Server_URL}/delivery-collections`, {
      params: {
        warehouse_id: warehouseId,
        page: page,
        per_page: perPage
      }
    });
  }

  createDeliveryCollection(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/delivery-collections`, data);
  }

  getDeliveryCollectionById(id: string): Observable<any> {
    return this.http.get(`${environment.Server_URL}/delivery-collections/${id}`);
  }

  updateDeliveryCollection(id: string, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/delivery-collections/${id}`, data);
  }

  deleteDeliveryCollection(id: string): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/delivery-collections/${id}`);
  }

  getCollectionsByStarAndDate(starId: number, date: string): Observable<any> {
    return this.http.post(`${environment.Server_URL}/delivery-collections/by-hero-date`, {
      deliveryhero_id: starId,
      date: date
    });
  }

  // =========================
  // Sales Collections
  // =========================
  getAllSalesCollections(filters?: {
    user_id?: number;
    date?: string;
    month?: string;
  }): Observable<any> {
    const params: any = {};

    if (filters?.user_id) params.user_id = filters.user_id.toString();
    if (filters?.date) params.date = filters.date;
    if (filters?.month) params.month = filters.month;

    return this.http.get(`${environment.Server_URL}/sales-collections`, { params });
  }
}
